import { Component, EventEmitter, Output, ChangeDetectorRef } from '@angular/core';
import { DashboardService } from '../../services/dashboard.service';
import { MessageService } from '../../services/message.service';

declare var $: any;

@Component({
  selector: 'magic-insights-question-writer',
  templateUrl: './magic-insights-question-writer.component.html',
  styleUrls: ['./magic-insights-question-writer.component.css'],
  standalone: false,
})
export class MagicInsightsQuestionWriterComponent {
  @Output() questionCreated = new EventEmitter<void>();

  selectedModule: any = null;
  newQuestionText: string = '';
  isCreating: boolean = false;
  currentStepText: string = '';

  private creationSteps: string[] = [
    'Verifying Question Plausibility...',
    'Rewriting Question for Compatibility...',
    'Crafting Display Mechanism...',
    'Generating Useful Filters...',
    'Finishing Up...'
  ];

  constructor(
    private dashboardService: DashboardService,
    private messageService: MessageService,
    private cdr: ChangeDetectorRef // Added ChangeDetectorRef
  ) {}

  open(moduleSection: any): void {
    this.selectedModule = moduleSection;
    this.newQuestionText = '';
    this.isCreating = false;
    this.currentStepText = '';
    $('#magicQuestionWriterModal').modal('show');
  }

  close(): void {
    $('#magicQuestionWriterModal').modal('hide');
  }

  startCreation(): void {
    if (!this.newQuestionText || this.newQuestionText.trim().length < 3) return;

    this.isCreating = true;
    this.runCreationSteps(0); // Start animation loop

    // API Call
    this.dashboardService
      .createAiraModuleQuestion(this.selectedModule.value.id, this.newQuestionText)
      .subscribe({
        next: (data) => {
          if (data.id) {
            this.handleSuccess();
          }
        },
        error: (err) => {
          this.isCreating = false;
          this.close();
          this.messageService.show(
            'Something went wrong creating the question. Please try again.'
          );
          this.cdr.markForCheck(); // Ensure view updates on error
        }
      });
  }

  private runCreationSteps(index: number): void {
    if (!this.isCreating) return;

    if (index >= this.creationSteps.length) {
      // Stay on the last step until API finishes
      this.currentStepText = this.creationSteps[this.creationSteps.length - 1];
      this.cdr.markForCheck(); // Update view
      return;
    }

    this.currentStepText = this.creationSteps[index];
    this.cdr.markForCheck(); // Update view immediately after changing text

    // Random duration between 5s and 10s
    const randomDelay = Math.floor(Math.random() * 5000) + 5000;

    setTimeout(() => {
      this.runCreationSteps(index + 1);
    }, randomDelay);
  }

  private handleSuccess(): void {
    this.currentStepText = 'Finishing Up...';
    this.cdr.markForCheck(); // Update view

    // Small delay to ensure user sees "Finishing Up"
    setTimeout(() => {
        this.close();
        this.isCreating = false;
        this.messageService.showInfo('New question created successfully!');
        this.questionCreated.emit();
        this.cdr.markForCheck(); // Final update
    }, 1500);
  }
}
